/*******************************************************************************
  ManageTenants.js

  Author: Advait

 This file  is responsible for creating new tenants and updating exiting tenants for 
 Automation project.

 Current code is developed by newbie developer, so may not be standard
*******************************************************************************/
import React, { Component } from "react";
import { createTenant } from "../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import { showNotification } from "../components/helper/notification";
import TenantSiteStatus from "../components/TenantSiteStatus";

class ManageTenants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      createCompany: "",
      tenants: [],
      createButtonDisabled: true,
    };
    this.handleCreateTenant = this.handleCreateTenant.bind(this);
    this.handleChangeCompany = this.handleChangeCompany.bind(this);
  }

  async handleCreateTenant(event) {
    console.log("name of company : ", this.state.createCompany);
    event.preventDefault();
    event.stopPropagation();

    this.setState({ createButtonDisabled: true });
    if (this.state.createCompany === "") {
      showNotification("Please enter tenant name", "error");
      this.setState({ createButtonDisabled: false });
    } else {
      try {
        const tenant = {
          company: this.state.createCompany,
          disabled: false,
        };
        const response = await API.graphql(graphqlOperation(createTenant, { input: tenant }));
        this.setState({
          createCompany: "",
          createButtonDisabled: true,
        });
        if (response !== "") {
          showNotification("Tenant created successfully", "success");
        }
      } catch (e) {
        console.log(e);
        this.setState({ createButtonDisabled: false });
      }
    }
  }

  handleChangeCompany(event) {
    const value = event.target.value.trim();
    this.setState({
      createCompany: event.target.value,
      createButtonDisabled: value === "",
    });
  }

  render() {
    return (
      <div className="fullPageDiv">
        <h3>Manage Tenant</h3>
        <div className="individualContainer">
          <form onSubmit={this.handleCreateTenant}>
            <table className="individualContainerTable">
              <tbody>
                <tr>
                  <td className="individualContainerTitleColumn" valign="top">
                    <h4 className="individualContainerTitleHeading">Create Tenant</h4>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td
                            className="individualContainerSubTitleColumn"
                            style={{ verticalAlign: "middle" }}
                          >
                            <h6>Enter Company Name</h6>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <input
                              className="inputField"
                              style={{ paddingLeft: "5px" }}
                              type="text"
                              placeholder="Company Name"
                              value={this.state.createCompany}
                              onChange={this.handleChangeCompany}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td className="individualContainerTitleColumn" valign="top"></td>
                  <td style={{ padding: "0 0 15px 0" }}>
                    <button
                      className="saveButton"
                      type="submit"
                      disabled={this.state.createButtonDisabled}
                    >
                      Create
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <TenantSiteStatus entityType="tenant" />
      </div>
    );
  }
}

export default ManageTenants;
